<template>
    <nav class="pager">
        <ul class="pagination flex" style="list-style: none;">
            <li v-if="pagination.current_page > 1" class="pager__item--previous">
                <a v-on:click.prevent="changePage(pagination.current_page - 1)"><i class="prev icon-arrow-right"></i></a>
            </li>

            <li v-for="page in pagesNumber" :class="{'is-active': page == pagination.current_page, 'last': page === pagesNumber[pagesNumber.length-1]}" class="number">
                <a v-on:click.prevent="changePage(page)">{{ page }}</a>
            </li>

            <li v-if="pagination.current_page < (pagination.last_page)" class="pager__item--next">
                <a v-on:click.prevent="changePage(pagination.current_page + 1)"><i class="next icon-arrow-right"></i></a>
            </li>
        </ul>
    </nav>
</template>

<script>
    export default {
        props: ['pagination', 'params', 'offset'],
        mounted() {

        },
        computed: {
            pagesNumber: function() {
/*                if (!this.pagination.to) {
                    return [];
                }*/

                let deltaFrom = this.pagination.last_page - this.pagination.current_page;
                if(deltaFrom <= 0)
                    deltaFrom = 2;

                let from = this.pagination.current_page - (this.pagination.current_page <= (this.pagination.last_page - this.offset) ? this.offset : this.offset + deltaFrom);
                if (from < 1) {
                    from = 1;
                }

                let to = this.pagination.current_page + (this.pagination.current_page > this.offset ? this.offset : this.offset + (this.offset - (this.pagination.current_page-1)) );
                if (to >= this.pagination.last_page) {
                    to = this.pagination.last_page;
                }

                let pagesArray = [];
                for (let page = from; page <= to; page++) {
                    pagesArray.push(page);
                }

                return pagesArray;
            }
        },
        methods: {
            changePage(page) {
                this.params.page = page;
                // this.$emit('addHistory');
                this.$emit('paginate');
            }
        }
    }
</script>